import React from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DateTime } from 'luxon';

import FieldLabelAndValue from '../../components/FieldLabelAndValue';
import { RepaymentSchedule } from '../../types';
import DollarAndCentsText from '../../components/DollarAndCentsText';
import FieldValue from '../../components/FieldValue';
import InfoIcon from '../../components/svg/InfoIcon';

const useStyles: any = makeStyles((theme: any) => ({
  guarantorsContainer: {
    margin: theme.spacing(1.5, 3),
  },
  box: {
    border: `1px solid ${theme.palette.grey['300']}`,
    borderRadius: 4,
    padding: theme.spacing(1),
    backgroundColor: theme.palette.info['700'],
  },
  mainContent: {
    paddingLeft: theme.spacing(0.5),
  },
  icon: {
    paddingTop: theme.spacing(0.5),
    '& svg': {
      fontSize: '1.25rem',
    },
  },
}));

interface Props {
  repaymentSchedule: RepaymentSchedule;
}

const RepaymentDetails = (props: Props) => {
  const { repaymentSchedule } = props;
  const classes = useStyles();

  return (
    <Grid className={classes.guarantorsContainer}>
      <FieldLabelAndValue label='Repayments' dataTestId='uia-repaymentSchedule'>
        <FieldValue dataTestId='uia-amount'>
          <DollarAndCentsText amount={repaymentSchedule.amount} />
        </FieldValue>
        <Box className={classes.box} display='flex' alignItems='center'>
          <Grid container>
            <Grid item xs={1} className={classes.icon}>
              <InfoIcon />
            </Grid>
            <Grid item xs={11} className={classes.mainContent}>
              <Typography variant='body1' component='p' data-testid='uia-body'>
                {repaymentSchedule.term} {repaymentSchedule.paymentFrequency.toLowerCase()} instalments of{' '}
                <DollarAndCentsText amount={repaymentSchedule.amount} /> commencing on{' '}
                {DateTime.fromISO(repaymentSchedule.dueDate).toFormat('dd MMM yyyy')}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </FieldLabelAndValue>
    </Grid>
  );
};

export default RepaymentDetails;
